module.exports = __webpack_public_path__ + "img/vertical_3_7_7016.dac8f8ec.png";